import { FC, useEffect, useMemo, useState } from 'react';
import Link from './Link';
import {
  Attributes,
  TableColumn,
  getReplacedTemplateLiteralByAttributes,
  getReplacedTemplateLiteralByAttributesUrlEncoded,
} from '../DataGrid';
import { Row } from '@tanstack/react-table';
import { useTemplateStore } from '../DashboardViewer/hooks/TemplateProvider';

interface LinkRendererProps {
  baseUrl: string;
  path: string;
  displayText: string;
  row: Row<TableColumn>;
  value: string | number | null;
  pathAttributes?: Attributes;
  displayTextAttributes?: Attributes;
  className?: string;
  openInNewTab?: boolean;
}

// todo: consolidate link components if possible
export const LinkRenderer: FC<LinkRendererProps> = ({
  baseUrl,
  path,
  displayText,
  row,
  value,
  pathAttributes,
  displayTextAttributes,
  className = '',
  openInNewTab = false,
}) => {
  const [globals] = useTemplateStore((store: unknown) => (store as Record<string, unknown>).globals);
  const [linkPath, setLinkPath] = useState(path);
  const [linkText, setLinkText] = useState(displayText ?? value);
  const href = useMemo(
    () => `${baseUrl ?? (globals as Record<string, unknown>).baseUrl}${linkPath}`,
    [baseUrl, globals, linkPath],
  );

  useEffect(() => {
    // process values from table to form path used for link
    const processLink = async () => {
      const pathForLink = await getReplacedTemplateLiteralByAttributesUrlEncoded(path, row, pathAttributes);
      setLinkPath(pathForLink);
    };
    if (path && pathAttributes && Object.keys(pathAttributes).length > 0) {
      processLink();
    }
  }, [pathAttributes, path, row]);

  useEffect(() => {
    // process values from table to form display text for link
    const processLinkText = async () => {
      const textForLink = await getReplacedTemplateLiteralByAttributes(displayText, row, displayTextAttributes);
      setLinkText(textForLink);
    };
    if (displayText && displayTextAttributes) {
      processLinkText();
    }
  }, [displayText, row, displayTextAttributes]);

  return (
    <Link href={href} className={className} target={openInNewTab ? '_blank' : '_self'}>
      {linkText}
    </Link>
  );
};
